<template>
  <div class="exchange-settlement-detail">
    <div class="order-step">
      <div class="el-steps el-steps--horizontal">
        <div
          class="el-step is-horizontal is-center"
          style="flex-basis: 25%;"
          v-for="(obj,idx) in orderTrack"
          :key="idx"
        >
          <div
            class="el-step__head "
            :class="{'is-finish': obj.status}"
          >
            <div class="el-step__line"></div>
            <div class="ab-icon is-text">
              <div class="el-step__icon-inner">
                <ab-svg :name="obj.icon"></ab-svg>
              </div>
            </div>
          </div>
          <div class="el-step__main">
            <div
              class="el-step__title"
              :class="{'is-finish': obj.status}"
            >{{obj.name}}</div>
            <div class="el-step__description">{{obj.createDate}}</div>
          </div>
        </div>
      </div>
    </div>

    <detailEdit 
      v-if="[undefined, 'add', 'wait', 'import', 'out', 'edit'].includes(routeQuery.action)"
      :routeQuery="routeQuery"
      :options="options"
      :dataForm="dataForm"
      :linkParames="linkParames"
      :requiredRemark="requiredRemark"
      @payList-change="setPaymentAppPayVoList"
      @reload="init"
      ref="detailEdit"
      @resetUpload="saleAttachFileCheck"
    ></detailEdit>

    <detailView
      v-if="routeQuery.action === 'view'"
      :routeQuery="routeQuery"
      :options="options"
      :dataForm="dataForm"
      :linkParames="linkParames"
      ref="detailView"
    ></detailView>

    <ab-upload
      v-if="uploadParams.items && uploadParams.items.length > 0"
      :params="uploadParams"
      :disabled="routeQuery.action === 'view'"
      @update-billsId="updateBillsId"
      ref="fileUpload"
    ></ab-upload>
    <ab-footer v-if="!linkParames.id" >
      <el-button @click="back">返回</el-button>

      <template v-if="[undefined, 'add', 'wait', 'import', 'out', 'edit'].includes(routeQuery.action)">
        <el-button
          v-if="$isAuth('customer:account:pay:edit') && (dataForm.paymentAppVo.clientStatus == '01' || !dataForm.paymentAppVo.clientStatus)"
          @click="validate('save')"
          :loading="btnLoading"
        >保存</el-button>
        
        <el-button
          type="primary"
          v-if="$isAuth('customer:account:pay:submit') && (dataForm.paymentAppVo.clientStatus == '01' || !dataForm.paymentAppVo.clientStatus)"
          @click="validate('confirm')"
          :loading="btnLoading"
        >提交</el-button>
      </template>
      
      <el-button
        v-if="dataForm.paymentAppVo.clientStatus == '05' && dataForm.paymentAppVo.esignStatus != -1 && $isAuth('customer:account:pay:submit')"
        type="primary"
        @click="revoke"
      >修改</el-button>

      <ab-continue-sign
        :show="dataForm.paymentAppVo.clientStatus == '02-1'"
        billType="03"
        :customerBillNumber="dataForm.paymentAppVo.clientNumber"
        v-if="$isAuth('customer:account:pay:submit')"
        @handleClose="init"
      >继续签章</ab-continue-sign>

      <ab-revoke-sign
        :billId="dataForm.paymentAppVo.id"
        :show="dataForm.paymentAppVo.clientStatus == '02-1'"
        v-if="$isAuth('customer:account:pay:submit')"
        @callback="back"
      >撤回签章</ab-revoke-sign>
    </ab-footer>

    <ab-preview :preview="preview" @handleClose="signCompleted">
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="signCompleted()">取 消</el-button>
          <el-button type="primary" @click="signCompleted()">确 认</el-button>
        </span>
      </template>
    </ab-preview>

    <!-- 付款明细 -->
    <payment-details @close="closePaymentDrawer" ref="paymentDetails"></payment-details>
  </div>
</template>

<script>
import detailEdit from './exchange-settlement-detail-edit.vue'
import detailView from './exchange-settlement-detail-view.vue'
import paymentDetails from './payment-details-drawer.vue'

export default {
  name: 'exchange-settlement-detail',
  components: {
        detailEdit,
        detailView,
        paymentDetails
  },
  
  props: {
    linkParames: {
      type: String,
      default: {}
    }
  },

  data() {
    return {
      routeQuery: {},
      options: {},
      dataForm: {
        paymentAppVo: {},
        paymentAppPayVoList: []
      },
      requiredRemark: false,
      tempBillId: null,
      uploadParams: {
        coreBillIds: '',
        coreBillNumbers: '',
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'PaymentApp',
        billType: '',
        initAttachMap: {},
        items: []
      },
      btnLoading: false,
      preview: {
        show: false,
        isView: false,
        isAgree: true,
        isFooter: true,
        fileUrl: ''
      },

      orderTrack: [
        {
          status: 0,
          name: '申请提交',
          createDate: '',
          icon: 'order-tijiao'
        },
        {
          status: 0,
          name: '付外币',
          createDate: '',
          icon: 'waibi'
        },
        {
          status: 0,
          name: '处理中',
          createDate: '',
          icon: 'chuli'
        },
        {
          status: 0,
          name: '已完成',
          createDate: '',
          icon: 'wancheng'
        }
      ]
    }
  },

  watch : {
    'linkParames.id': function(value) { // 商务端工作流页面嵌套
      this.routeQuery.id = this.linkParames.id
      this.init()
    },

    'dataForm.paymentAppVo.disableUnitId': function(value) { // 委托收款
      if (value) {
        this.uploadParams.items = this.uploadParams.items.filter((item) => {
          return item.title !== '收款授权书'
        })
        this.uploadParams.items.push({
          title: '收款授权书',
          attachType: '080',
          required: true,
        })
      } else {
        this.uploadParams.items = this.uploadParams.items.filter((item) => {
          return item.title !== '收款授权书'
        })
      }
    },

    $route(to, from) {
      if (to.path === '/exchange-settlement-detail') {
        this.routeQuery = Object.keys(to.query).length ? to.query : this.routeQuery
        if (
          typeof this.routeQuery.cache === "string"
            ? JSON.parse(this.routeQuery.cache)
            : this.routeQuery.cache
        ) {
          return false
        } else {
          this.routeQuery.cache = true
        }
        if (this.linkParames.id) { // 商务端工作流页面嵌套
          this.routeQuery.id = this.linkParames.id
        }
        this.init()
      }
    }
  },

  computed: {
    mainTabs: {
      get() {
        return this.$store.state.mainTabs
      },
      set(val) {
        this.$store.commit('updateMainTabs', val)
      }
    },

    mainTabsActiveName: {
      get() {
        return this.$store.state.mainTabsActiveName
      },
      set(val) {
        this.$store.commit('updateMainTabsActiveName', val)
      }
    }
  },

  mounted() {
    this.getSelectList()    
  },

  activated() {
    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    if (this.linkParames.id) { // 商务端工作流页面嵌套
      this.routeQuery.id = this.linkParames.id
    }
    if (
      typeof this.routeQuery.cache === "string"
        ? JSON.parse(this.routeQuery.cache)
        : this.routeQuery.cache
    ) {
      return false
    } else {
      this.routeQuery.cache = true
    }
    this.init()
  },

  methods: {
    removeTabHandle(tabName) {
        this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
        if (tabName) {
            this.$router.push({ path: this.routeQuery.path || `/exchange-settlement-record-list` }) 
        }
    },

    getSelectList() {
      this.$get('/sms/client/paymentApp/getSelect').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    init() {
      if (this.routeQuery.id) { // 编辑/详情
        this.$get('/sms/client/paymentApp/get', { id: this.routeQuery.id }).then(({ data }) => {
          if (data.code === 'C0000') {
            this.handleData(data.result)
          }
        })
      } else if (['wait', 'import', 'out'].includes(this.routeQuery.action) && this.routeQuery.result) { // 待付汇新增 || 订单-付汇申请
        let result = JSON.parse(this.routeQuery.result)
        result.paymentAppVo.applyDate = this.$utils.getDate(new Date())
        this.handleData(result)
      } else { // 新增
        this.handleData({
          paymentAppVo: {
            billType: 1, // 新增进来的
            paymentType: '01',  //货款
            applyDate: this.$utils.getDate(new Date()), // 申请日期：今天
            paymentMode: '05', // 付款方式: T/T
            claimDate: this.$utils.getDate(new Date()), // 要求付款日：今天
            feeBearer: 1, // 手续费承担：我司承担
            isAdvance: false // 垫资：否
          },
          paymentAppPayVoList: []
        })
      }
    },

    // 处理请求接口数据
    handleData(result) {
      // 进度条
      const clientStatus = result.paymentAppVo.clientStatus
      // 申请提交
      this.orderTrack[0].status = ['02-1', '05', '06', '08', '10'].includes(clientStatus) && result.paymentAppVo.confirmTime
      this.orderTrack[0].createDate = result.paymentAppVo.confirmTime
      // 付人民币
      this.orderTrack[1].status = ['05', '06', '08', '10'].includes(clientStatus) && result.paymentAppVo.waitPayTime
      this.orderTrack[1].createDate = result.paymentAppVo.waitPayTime
      // 处理中
      this.orderTrack[2].status = ['06', '08', '10'].includes(clientStatus) && result.paymentAppVo.inPaymentTime
      this.orderTrack[2].createDate = result.paymentAppVo.inPaymentTime
      // 已完成
      this.orderTrack[3].status = ['10'].includes(clientStatus) && result.paymentAppVo.billCompletedTime
      this.orderTrack[3].createDate = result.paymentAppVo.billCompletedTime
      this.uploadParams.initAttachMap = result.initAttachMap
      this.dataForm = result
      this.initUpload()
      // 初始化数据
      if (this.routeQuery.action !== 'view') { // 新增，编辑，引入
        setTimeout(() => {
          this.$refs.detailEdit.getBizTypeList()
          this.$refs.detailEdit.getBankList(!!this.dataForm.paymentAppVo.id) // 新增 & 引入 初始化银行
        }, 500)
      }
    },

    setPaymentAppPayVoList(value) {
      if(value && value.length) {
        let ids = value.map(e=>{if(e.coreBillId){return e.coreBillId}})
        this.$post('/sms/client/paymentApp/querySuppPiFiles', ids).then(({data}) => {
          if(data && data.code === 'C0000') {
            if(data.result && data.result.length) {
              if(this.uploadParams.initAttachMap && this.uploadParams.initAttachMap['100']) {
                let list = []
                data.result.forEach(row => {
                  if (!this.uploadParams.initAttachMap['100'].map(e => e.id).includes(row.id)) {
                    list.push(row)
                  }
                })
                this.uploadParams.initAttachMap['100'] = this.uploadParams.initAttachMap['100'].concat(list)
              } else {
                this.uploadParams.initAttachMap = {'100': data.result}
              }
              this.initUpload()
              return
            }
          }
        })
      }
      this.initUpload()
    },

    initUpload(flag) {
      // 初始化上传组件
      this.uploadParams.sourceBillId = this.dataForm.paymentAppVo.id
      this.uploadParams.sourceBillNumber = this.dataForm.paymentAppVo.number

      if (this.dataForm.paymentAppPayVoList) {
        let coreBillNumber = []
        let coreBillId = []
        this.dataForm.paymentAppPayVoList.map((row) => {
          if (!coreBillNumber.includes(row.coreBillNumber)) {
            coreBillNumber.push(row.coreBillNumber)
            coreBillId.push(row.coreBillId)
          }
        })
        this.uploadParams.coreBillIds = coreBillId
        this.uploadParams.coreBillNumbers = coreBillNumber
      }

      let items = [
        {
          title: '请款书',
          attachType: this.dataForm.paymentAppVo.paymentType === '01' ? '030' : '040',
          required: false
        },
        {
          title: '货款水单',
          attachType: '010',
          required: false,
          isDelete: true
        }
      ]
      if (this.dataForm.paymentAppVo.disableUnitId) {
        items.push({
          title: '收款授权书',
          attachType: '080',
          required: true
        })
      }
      if (['03', '04', '06'].includes(this.dataForm.paymentAppVo.bizType) && this.dataForm.paymentAppVo.paymentType === '01') {
        items.push({
          title: '销售订单',
          attachType: '090',
          required: flag || false,
        })
      }
      if (this.dataForm.paymentAppVo.isAdvance || (this.uploadParams.initAttachMap && this.uploadParams.initAttachMap['100'] && this.uploadParams.initAttachMap['100'].length) || (this.$refs.fileUpload && this.$refs.fileUpload.fileData && this.$refs.fileUpload.fileData['100'] && this.$refs.fileUpload.fileData['100'].length)) {
        items.push({
          title: '供应商PI',
          attachType: '100',
          required: this.dataForm.paymentAppVo.isAdvance,
        })
      }
      this.uploadParams.items = items
    },

    // 销售附件
    saleAttachFileCheck() {
      let flag = false
      if (this.dataForm.paymentAppPayVoList.length > 0) {
        this.$post('/sms/client/paymentApp/saleAttachFileCheck', this.dataForm.paymentAppVo).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.initUpload(data.result)
          }
        })
      }
      this.initUpload(flag)
    },

    // 附件临时id
    updateBillsId(tempBillId) {
      this.tempBillId = tempBillId
    },

    // 返回
    back() {
        if (this.dataForm.paymentAppVo.clientStatus == '01' && this.dataForm.paymentAppPayVoList.length > 0 && !this.dataForm.paymentAppVo.clientValidTips) {
            this.$confirm('为尽快处理贵司的账务，关联订单编号的付款申请草稿，系统将保留3天，逾期未提交，系统将自动取消此申请, 望尽快提交，谢谢！', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeTabHandle(this.mainTabsActiveName)
            }).catch(() => { }).finally(() => {
                this.$post(`/sms/client/paymentApp/updateTips?id=${this.dataForm.paymentAppVo.id}`).then(({ data }) => {
                    if (data.code == 'C0000' && data.message == '操作成功'){
                        this.dataForm.paymentAppVo.clientValidTips = 1
                    }
                })
            })
        } else {
            this.removeTabHandle(this.mainTabsActiveName)
        }
    },

    // 修改（撤回）
    revoke() {
      this.$confirm('确定要修改吗?修改后需要重新提交，请谨慎操作！', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
      }).then(() => {
        this.$get('/sms/client/paymentApp/withdraw', {
          id: this.dataForm.paymentAppVo.id,
        }).then(({ data }) => {
          if (data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            this.$router.push({
              path: '/exchange-settlement-detail',
              query: {
                action: 'edit',
                id: this.dataForm.paymentAppVo.id
              }
            })
          }
        })
      }).catch(() => {})
    },

    // 校验函数
    validate(type) {
      // 备注是否必填
      if (this.dataForm.paymentAppPayVoList.length === 0 && type === 'confirm') {
        this.requiredRemark = true
      } else {
        this.requiredRemark = false
      }
      if (this.requiredRemark && !this.dataForm.paymentAppVo.remarkPreClient) {
        return
      }
      this.$refs.detailEdit.$refs.dataForm.validate(valid => {
        if (valid) {
          // 未勾选委托收款
          if (!this.dataForm.paymentAppVo.disableUnitId) {
            // 当付款明细中【供应商】不为空，【收款方】不允许和【供应商】不一致
            for (let row of this.dataForm.paymentAppPayVoList) {
              if (row.supplierName) {
                if (row.supplierName !== this.dataForm.paymentAppVo.revIdDesc) {
                  return this.$message({
                    type: 'error',
                    message: '非委托第三方收款，收款方必须和供应商一致',
                    offset: 380,
                    grouping: true
                  })
                }
              }
            }
          }
          if (this.dataForm.paymentAppVo.revBankAccount === this.dataForm.paymentAppVo.swiftCode) {
            this.$message.error('银行账号和SWIFT号不可能完全相同，请检查！') 
            return
          }
            // 确认
            if (type === 'confirm') {
                this.$refs.fileUpload.validate().then(fileValid => {
                    if (fileValid) {

                        let params = {
                            signFileUrl: this.preview.fileUrl,
                            operation: '02',
                            paymentAppVo: this.dataForm.paymentAppVo,
                            paymentAppPayVoList: this.dataForm.paymentAppPayVoList,
                            paymentAppRevVoList: this.dataForm.paymentAppPayVoList,
                            tempBillId: this.tempBillId,
                        }
                        this.$post('/sms/client/paymentApp/checkRepeatRecAndAmount', params).then(({data}) => {
                            if(data.code === 'C0000') {
                                if(data.message && data.message.indexOf('成功') != -1) {
                                    this.submitForm()
                                }else{
                                    this.$message.error(data.message)
                                }
                            }
                        })
                    }
                })
            } else {
                this.handerAffirm(type)
            }
        }
      })
    },

    // 确认
    handerAffirm(type, flag = false){
      let data = {
        signFileUrl: this.preview.fileUrl,
        operation: type === 'submit' ? '02' : '01',
        paymentAppVo: this.dataForm.paymentAppVo,
        paymentAppPayVoList: this.dataForm.paymentAppPayVoList,
        tempBillId: this.tempBillId,
        initAttachMap: this.uploadParams.initAttachMap
      }
      if(flag) {
        data.continueSubmit = true
      }
      this.btnLoading = true
      this.$post('/sms/client/paymentApp/add', data).then(({ data }) => {
        if (data.code === 'C0000') {
          this.$message({
            type: 'success',
            message: data.message,
            offset: 380,
            grouping: true
          })
          if (!this.routeQuery.id) {
            this.routeQuery.id = data.result
          }
          if (type === 'save') {
            this.init()
          } else if (type === 'submit') {
            this.preview.show = false
            if (data.extra) {
              this.preview.isView = true
              this.preview.fileTitle = '请款书'
              this.preview.fileUrl = data.extra
              this.preview.show = true
            } else {
              this.openPaymentDrawer()
            }
          }
        }
        if(data.code === 'E0008'){
          if(data.message && data.message.indexOf('中国') != -1) {
            this.$alert(data.message, '温馨提示', {
              confirmButtonText: '我知道了',
              callback: action => {
              }
            });
          }
          if(data.message && data.message.indexOf('中国') == -1) {
            this.$confirm(data.message, '温馨提示', {
              confirmButtonText: '继续提交',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.handerAffirm(type, true)
            })
          }
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },

    submitForm() {
      if (this.dataForm.paymentAppVo.isSplit && !this.dataForm.paymentAppPayVoList[this.dataForm.paymentAppPayVoList.length - 1].coreBillId) {
        let handleAmount = 0  // 应付
        let prepaidAmount = 0  // 预付
        this.dataForm.paymentAppPayVoList.forEach(ele=>{
          if (ele.isSplit) {
            prepaidAmount += ele.applyAmount
          } else {
            handleAmount += ele.applyAmount
          }
        })
        let handleNumber = this.dataForm.paymentAppVo.clientNumber // 应付单号
        let prepaieNumber = this.dataForm.paymentAppVo.splitClientNumber  // 预付单号
        let currency = this.dataForm.paymentAppVo.applyCurrencyIdDesc
        this.$confirm(`本单申请金额大于订单可付款金额，系统将为您拆成2单，应付：${handleAmount} ${currency} 申请单号：${handleNumber}； 预付： ${prepaidAmount} ${currency} 申请单号 ${prepaieNumber}`, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handerAffirm('submit')
        })
      } else {
        this.handerAffirm('submit')
      }
    },

    // 签章完成
    signCompleted() {
      this.preview.show = false
      setTimeout(() => {
        this.openPaymentDrawer()
      }, 1000)
    },

    openPaymentDrawer() {
      let id = this.dataForm.paymentAppVo.id || this.routeQuery.id
      let billType = this.dataForm.paymentAppVo.billType || 1
      this.$refs.paymentDetails.init(id, billType)
    },

    closePaymentDrawer() {
      this.removeTabHandle(this.mainTabsActiveName)
    }
  }
}
</script>

<style lang='scss'>
.exchange-settlement-detail {
  position: relative;
  .order-step {
    padding: 30px;
    margin: 0 8%;
    .ab-icon {
      .el-step__icon-inner {
        padding: 13px 16px;
        height: 64px;
        width: 64px;
        background-color: #f2f7ff;
        border-radius: 8px;
      }
      .icon-svg {
        width: 33px;
        height: 36px;
      }
    }
    .el-step__line {
      left: 56%;
      right: -41%;
      margin: 20px;
      background: none;
      width: 100%;
      height: 2px;
      background-image: linear-gradient(
        to right,
        rgb(214, 214, 214) 0%,
        rgb(214, 214, 214) 50%,
        transparent 50%
      );
      background-size: 15px 1px;
    }
    .el-step__title {
      color: #000000;
      font-weight: 500;
      &.is-finish {
        color: #0A7CFF;
      }
    }
    .el-step__description {
      color: #636871;
    }
  }
  .ab-file-upload {
    .upload {
      padding-bottom: 40px;
    }
  }
  .footer {
    padding: 20px 0;
  }
}
</style>
